import { render, staticRenderFns } from "./NotificationSnackbar.vue?vue&type=template&id=bd6d2a62&scoped=true&"
import script from "./NotificationSnackbar.vue?vue&type=script&lang=js&"
export * from "./NotificationSnackbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd6d2a62",
  null
  
)

export default component.exports